import { graphTrunkNodeId } from './graph'
import * as Model from '../types/document'
import { Cursor } from 'src/lib/Cursor';

export function lastNodeIdInSteps (steps: Model.Steps): Model.NodeId | undefined {
  for (let i = steps.length - 1; i >= 0; i--) {
    const maybeLastNodeId = lastNodeIdInStep(steps[i])
    if (maybeLastNodeId) { return maybeLastNodeId }
  }
  return undefined
}

export function lastNodeIdInStep (step: Model.Step): Model.NodeId | undefined {
  switch (step.stepType) {
  case 'graph':
    return graphTrunkNodeId(step)
  case 'switch':
    return step.output.id
  case 'text':
    return undefined
  }
}

export function parentSteps (stepC: Cursor<Model.Step>): Cursor<Model.Steps> {
  return stepC.parent() as Cursor<Model.Steps>
}



// WEBPACK FOOTER //
// ./src/model/steps.ts